import {
  type LayerProps,
  createElementObject,
  createTileLayerComponent,
  updateGridLayer,
  withPane,
} from "@react-leaflet/core"
import L from "leaflet"
import "@maplibre/maplibre-gl-leaflet"
import { setWorkerUrl } from "maplibre-gl"
import workerUrl from "url:maplibre-gl/dist/maplibre-gl-worker.mjs"

// MapLibre's relative worker discovery cannot survive Parcel bundling.
// Emit the worker (and its imports) as assets shared by every map consumer.
setWorkerUrl(workerUrl);

export interface MapLibreTileLayerProps extends L.LeafletMaplibreGLOptions, LayerProps {
  // A MapLibre GL style: either a URL string (served style) or a bundled style
  // specification object (imported JSON). maplibre-gl accepts both.
  url: string | object;
  attribution: string;
}

export const MapLibreTileLayer = createTileLayerComponent<
  L.MaplibreGL,
  MapLibreTileLayerProps
>(
  function createTileLayer({ url, attribution, ...options }, context) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const maplibreGL = L.maplibreGL as unknown as any;
    const layer = maplibreGL({ style: url, attribution: attribution, noWrap: true }, withPane(options, context));
    return createElementObject(layer, context);
  },
  function updateTileLayer(layer, props, prevProps) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const update = updateGridLayer as unknown as any;
    update(layer, props, prevProps);

    const { url, attribution } = props;
    if (url != null && url !== prevProps.url) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
      (layer.getMaplibreMap() as any).setStyle(url);
    }

    if (attribution != null && attribution !== prevProps.attribution) {
      layer.options.attribution = attribution;
    }
  },
);
